import { OnInit, EventEmitter, QueryList, AfterContentInit, OnDestroy } from '@angular/core';
import { ColumnGroupComponent } from '../column-group/column-group.component';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
var ColumnGroup = /** @class */ (function () {
    function ColumnGroup(index, label, component) {
        this.index = index;
        this.label = label;
        this.component = component;
    }
    return ColumnGroup;
}());
var ColumnComponent = /** @class */ (function () {
    function ColumnComponent() {
        this.showHeader = true;
        this.loading = false;
        this.loadingLabel = '';
        this._selectedColumnGroup = new BehaviorSubject(0);
        this.selectedColumnGroupChange = new EventEmitter();
        this.next = new EventEmitter();
        this.previous = new EventEmitter();
        this.ngUnsubscribe = new Subject();
    }
    Object.defineProperty(ColumnComponent.prototype, "selectedColumnGroup", {
        get: function () {
            return this._selectedColumnGroup.value;
        },
        set: function (value) {
            if (value != null && value !== this.selectedColumnGroup) {
                if (typeof value === 'string') {
                    value = value.toUpperCase();
                }
                this._selectedColumnGroup.next(value);
                this.selectedColumnGroupChange.emit(value);
            }
        },
        enumerable: true,
        configurable: true
    });
    ColumnComponent.prototype.ngOnInit = function () {
    };
    ColumnComponent.prototype.ngAfterContentInit = function () {
        var _this = this;
        this.mapContentGroups();
        this._selectedColumnGroup
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (columnGroup) {
            _this.showColumnGroup(columnGroup);
        });
    };
    ColumnComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    ColumnComponent.prototype.handleColumnGroupSelect = function (columnGroup) {
        // this._selectedColumnGroup.next(columnGroup.index);
        this.selectedColumnGroup = columnGroup.label;
    };
    ColumnComponent.prototype.mapContentGroups = function () {
        this.columnGroups = this.columnGroupsQuery.map(function (columnGroup, index) {
            return new ColumnGroup(index, columnGroup.label, columnGroup);
        });
    };
    ColumnComponent.prototype.showColumnGroup = function (selector) {
        this.columnGroups.forEach(function (group, index) {
            switch (typeof selector) {
                case 'number':
                    group.component.isActive = (selector === index);
                    break;
                case 'string':
                    group.component.isActive = (selector.toString().toUpperCase() === group.label.toUpperCase());
                    break;
            }
        });
    };
    ColumnComponent.prototype.isColumnGroupSelected = function (columnGroup) {
        var value = (typeof this._selectedColumnGroup.value === 'string') ? columnGroup.label.toUpperCase() : columnGroup.index;
        return value === this._selectedColumnGroup.value;
    };
    return ColumnComponent;
}());
export { ColumnComponent };
